import gsap from "gsap";
import { showContent } from "./showContent";

export const leaveTransition = () => {
    gsap.set('.overlay', {
        display: 'none', 
        top: '100vh',
        onComplete: () => {
            showContent();
        }
    });
}
